<app-page-layout [title]="canview() ? '' : 'Dashboard'" [hideHeader]="canview()" [hasFilters]="false">
  <div page-content class="flex flex-col gap-6 w-full">

    <!-- Welcome banner -->
    <div class="rounded-xl border border-surface-200/60 dark:border-surface-700/40 bg-surface-0 dark:bg-surface-900 px-6 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

      <div class="flex flex-col gap-1">
        <h2 class="text-xl font-bold text-text-main leading-tight">
          {{ greeting() }}, {{ roleLabel() }}
        </h2>
        <p class="text-sm text-text-muted">
          {{ today }}
        </p>
      </div>

      <!-- Punch clock widget -->
      <app-punch-clock />

    </div>

    @if (canview()) {
    <app-dashboard-grid />
    }
  </div>
</app-page-layout>
